import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import {UnitcodeDto} from './unit-code.dto'

export class AllUnitcodeResponseModel extends GlobalResponseObject {
    data?: UnitcodeDto[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: UnitcodeDto[]){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

